export default __webpack_public_path__ + "static/media/1988.248c6a90.jpg";